export const QUERY_CACHE_TIME = 1000 * 60 * 15;
export const TOKEN_STORAGE_KEY = '4gu5gSXaARd6mnJnlWadHItUv1N6uc';
